import React from 'react';

import { InputMask } from 'utils/inputMask';

import * as S from '../../Insurance.styles';

import { CombinedInputs } from '../CombinedInputs/CombinedInputs';

import * as Constants from './FullNameInputs.constants';
import { useFullNameInputsPresenter } from './FullNameInputs.presenter';

export const FullNameInputs = ({
  className,
  disabled,
  error,
  name,
  onChange,
  onChangeGender,
  value,
}) => {
  const presenter = useFullNameInputsPresenter({ error, name, onChange, onChangeGender, value });

  return (
    <CombinedInputs className={className}>
      <S.DaDataUiKit
        additionalData={Constants.LASTNAME_DADATA_ADDITIONAL_DATA}
        disabled={disabled}
        error={presenter.errors[Constants.NAMES.LASTNAME]}
        label="Фамилия"
        mask={InputMask.RUS_NAME_NEW}
        name={Constants.NAMES.LASTNAME}
        type="fio"
        value={presenter.values[Constants.NAMES.LASTNAME]}
        onChange={presenter.onChange}
      />
      <S.DaDataUiKit
        additionalData={Constants.FIRSTNAME_DADATA_ADDITIONAL_DATA}
        disabled={disabled}
        error={presenter.errors[Constants.NAMES.FIRSTNAME]}
        label="Имя"
        mask={InputMask.RUS_NAME_NEW}
        name={Constants.NAMES.FIRSTNAME}
        type="fio"
        value={presenter.values[Constants.NAMES.FIRSTNAME]}
        onChange={presenter.onChange}
      />
      <S.DaDataUiKit
        additionalData={Constants.PATRONYMIC_DADATA_ADDITIONAL_DATA}
        disabled={disabled}
        label="Отчество (если есть)"
        mask={InputMask.RUS_PATRONYMIC}
        name={Constants.NAMES.PATRONYMIC}
        type="fio"
        value={presenter.values[Constants.NAMES.PATRONYMIC]}
        onChange={presenter.onChange}
      />
    </CombinedInputs>
  );
};
